import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PerformanceAlerts = ({ alerts }) => {
  const getAlertStyle = (severity) => {
    const styles = {
      critical: {
        bg: 'bg-error/10',
        border: 'border-error',
        icon: 'AlertTriangle',
        iconColor: 'text-error',
        text: 'text-error'
      },
      warning: {
        bg: 'bg-warning/10',
        border: 'border-warning',
        icon: 'AlertCircle',
        iconColor: 'text-warning',
        text: 'text-warning'
      },
      info: {
        bg: 'bg-primary/10',
        border: 'border-primary',
        icon: 'Info',
        iconColor: 'text-primary',
        text: 'text-primary'
      }
    };
    return styles?.[severity] || styles?.info;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg bg-error/10">
            <Icon name="Bell" size={20} className="text-error" />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground">Performance Alerts</h3>
            <p className="caption text-muted-foreground">{alerts?.length} active alerts requiring attention</p>
          </div>
        </div>
      </div>
      <div className="space-y-3">
        {alerts?.map((alert, index) => {
          const style = getAlertStyle(alert?.severity);
          return (
            <div
              key={index}
              className={`${style?.bg} border ${style?.border} rounded-lg p-4 transition-smooth hover:shadow-md`}
            >
              <div className="flex items-start gap-3">
                <Icon name={style?.icon} size={20} className={`${style?.iconColor} flex-shrink-0 mt-0.5`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-2">
                    <div className="flex-1">
                      <h4 className="text-sm font-semibold text-foreground mb-1">{alert?.building}</h4>
                      <p className="text-sm text-foreground">{alert?.message}</p>
                    </div>
                    <span className={`caption ${style?.text} font-medium whitespace-nowrap`}>
                      {alert?.severity?.toUpperCase()}
                    </span>
                  </div>
                  
                  {alert?.recommendation && (
                    <div className="mt-3 p-3 bg-card rounded-lg">
                      <p className="text-sm font-medium text-foreground mb-1">Recommended Action:</p>
                      <p className="caption text-muted-foreground">{alert?.recommendation}</p>
                    </div>
                  )}

                  <div className="flex items-center justify-between mt-3">
                    <span className="caption text-muted-foreground">
                      Detected: {new Date(alert.timestamp)?.toLocaleDateString('en-US', { 
                        month: 'short', 
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                    <div className="flex items-center gap-2">
                      <Button variant="outline" size="sm" iconName="Eye" iconPosition="left">
                        View Details
                      </Button>
                      <Button variant="default" size="sm" iconName="CheckCircle" iconPosition="left">
                        Acknowledge
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {alerts?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="CheckCircle" size={48} className="text-success mx-auto mb-3" />
          <p className="text-sm font-medium text-foreground mb-1">All Systems Performing Well</p>
          <p className="caption text-muted-foreground">No performance alerts at this time</p>
        </div>
      )}
    </div>
  );
};

export default PerformanceAlerts;